/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_ListAwardTypesRow } from '../models/db_ListAwardTypesRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AwardTypes {
    /**
     * Get a list of award types
     * @returns db_ListAwardTypesRow OK
     * @throws ApiError
     */
    public static listAwardTypes(): CancelablePromise<Array<db_ListAwardTypesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/award-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
